
    // Clears the search input on click. We can't drive this from the
    // server alone because LiveView's "preserve focused input value"
    // behavior ignores a re-rendered value="" while the input is
    // focused, leaving the stale text visible. Clearing the DOM here
    // and dispatching `input` lets the form's existing
    // phx-change="search" handler do the rest, keeping client and
    // server in sync.
    export default {
      mounted() {
        this.el.addEventListener("click", (e) => {
          e.preventDefault();
          const input = this.el
            .closest("form")
            ?.querySelector("input[type=search]");
          if (!input) return;
          input.value = "";
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.focus();
        });
      },
    };
  